import React from 'react';
import PropTypes from 'prop-types';
import {includes} from 'lodash';
import {EARNING_STATUSES} from 'shared/utils';
import AdmissionLikelihoodTag from 'high-school-student/college-earnings/components/admission-likelihood-tag';
import NotEarningText from 'shared/college-earnings/components/not-earning-text';
import {EARNINGS_PROP_TYPES} from 'shared/college-earnings/utils';
import {ADMISSION_LIKELIHOOD_CATEGORY_PROP_TYPE} from '../prop-types';
import EarningStamp from 'shared/application-management/components/earning-stamp';
import styles from './likelihood-and-earnings-labels.module.scss';
import CollegeApplicationStatusMenu from 'shared/college-application-status/components/college-application-status-menu';

const propTypes = {
  earnings: PropTypes.shape(EARNINGS_PROP_TYPES).isRequired,
  admissionLikelihoodCategory: ADMISSION_LIKELIHOOD_CATEGORY_PROP_TYPE,
  isEarningStatusShown: PropTypes.bool,
  isApplicationStatusMenuShown: PropTypes.bool,
  isBalancedListInfoAvailable: PropTypes.bool,
};

const LikelihoodAndEarningsLabels = ({
  admissionLikelihoodCategory,
  isEarningStatusShown,
  isApplicationStatusMenuShown,
  isBalancedListInfoAvailable,
  earnings: {_id, amount, divisor, earningRelationship, applicationStatus, setCollegeAppStatus},
}) => {
  const isEarningAmountShown = includes(EARNING_STATUSES, earningRelationship.statusType);

  return (
    <div>
      {isBalancedListInfoAvailable && admissionLikelihoodCategory && (
        <div className={styles.labelContainer}>
          <AdmissionLikelihoodTag admissionLikelihoodScoreCategory={admissionLikelihoodCategory} />
        </div>
      )}

      {isEarningAmountShown && (
        <div className={styles.labelContainer}>
          <EarningStamp amount={amount} divisor={divisor} />
        </div>
      )}

      {isEarningStatusShown && (
        <div className={styles.labelContainer} data-testid="no-earning-text">
          <NotEarningText relationship={earningRelationship} />
        </div>
      )}

      {isApplicationStatusMenuShown && (
        <div className={styles.appStatusContainer}>
          <CollegeApplicationStatusMenu
            college={{_id}}
            collegeApplicationStatus={applicationStatus}
            setCollegeAppStatus={setCollegeAppStatus}
            showStatusContent={false}
            forceCompactView
          />
        </div>
      )}
    </div>
  );
};

LikelihoodAndEarningsLabels.propTypes = propTypes;

export default LikelihoodAndEarningsLabels;
